module.exports = __webpack_public_path__ + "img/stu_avatar_10.bb0d03d3.jpg";